import { render, staticRenderFns } from "./OsobaForma.vue?vue&type=template&id=39fb42bc&scoped=true&"
import script from "./OsobaForma.vue?vue&type=script&lang=js&"
export * from "./OsobaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fb42bc",
  null
  
)

export default component.exports